import { lazy } from 'react'

export const RightBarContainerAsync = lazy(() => import('./RightBarContainer'))